import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(20 * 60); // 20 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center justify-center space-x-2 text-2xl font-bold font-serif text-dark mt-4" data-id="element-9">
      <div className="bg-white px-4 py-2 rounded shadow-sm border border-beige-200" data-id="element-10">
        {String(minutes).padStart(2, '0')}
      </div>
      <span data-id="element-11">:</span>
      <div className="bg-white px-4 py-2 rounded shadow-sm border border-beige-200" data-id="element-12">
        {String(seconds).padStart(2, '0')}
      </div>
    </div>;
}